import { ColumnConfig } from '../hooks/useTablePreferences';

export const wellnessTipColumns: ColumnConfig[] = [
  { key: 'fromDate', label: 'From Date', defaultWidth: 170, minWidth: 130, visible: true, sortable: true, resizable: true, draggable: true },
  { key: 'active', label: 'Active', defaultWidth: 90, minWidth: 70, visible: true, sortable: true, resizable: true, draggable: true },
  { key: 'tip', label: 'Tip (preview)', defaultWidth: 350, minWidth: 200, visible: true, sortable: false, resizable: true, draggable: true },
  { key: 'createdAt', label: 'Created', defaultWidth: 130, minWidth: 100, visible: true, sortable: true, resizable: true, draggable: true },
];
